var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9244 16.6C24.107 11.91 20.6882 9 16.9995 9C13.3108 9 9.89199 11.91 8.07462 16.6C8.02508 16.7262 7.99951 16.8623 7.99951 17C7.99951 17.1377 8.02508 17.2738 8.07462 17.4C9.89199 22.09 13.3108 25 16.9995 25C20.6882 25 24.107 22.09 25.9244 17.4C25.9739 17.2738 25.9995 17.1377 25.9995 17C25.9995 16.8623 25.9739 16.7262 25.9244 16.6V16.6ZM16.9995 23C14.1475 23 11.4484 20.71 9.89199 17C11.4484 13.29 14.1475 11 16.9995 11C19.8515 11 22.5506 13.29 24.107 17C22.5506 20.71 19.8515 23 16.9995 23ZM16.9995 13C16.2877 13 15.592 13.2346 15.0001 13.6741C14.4083 14.1136 13.9471 14.7384 13.6747 15.4693C13.4023 16.2002 13.331 17.0044 13.4699 17.7804C13.6088 18.5563 13.9515 19.269 14.4548 19.8284C14.9581 20.3878 15.5993 20.7688 16.2974 20.9231C16.9955 21.0775 17.7191 20.9983 18.3767 20.6955C19.0343 20.3928 19.5963 19.8801 19.9917 19.2223C20.3872 18.5645 20.5982 17.7911 20.5982 17C20.5982 15.9391 20.2191 14.9217 19.5442 14.1716C18.8693 13.4214 17.9539 13 16.9995 13V13ZM16.9995 19C16.6436 19 16.2957 18.8827 15.9998 18.6629C15.7039 18.4432 15.4733 18.1308 15.3371 17.7654C15.2009 17.3999 15.1653 16.9978 15.2347 16.6098C15.3041 16.2219 15.4755 15.8655 15.7272 15.5858C15.9788 15.3061 16.2994 15.1156 16.6485 15.0384C16.9975 14.9613 17.3593 15.0009 17.6881 15.1522C18.0169 15.3036 18.2979 15.56 18.4956 15.8889C18.6933 16.2178 18.7989 16.6044 18.7989 17C18.7989 17.5304 18.6093 18.0391 18.2718 18.4142C17.9344 18.7893 17.4767 19 16.9995 19Z",
    fill: "#444F7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDark);
export default __webpack_public_path__ + "static/media/eye-dark.90a8ad29859a9432603e5db9c0df152d.svg";
export { ForwardRef as ReactComponent };